import { lookup } from '@paypalcorp/identitywebcomponents';

import { logLookup } from './fpti/iwcEmailLookupFpti';
import { logger } from '@/lib/logger';
import { getGlobals, updateIwcContext } from '@/lib/globals';
import { isDev } from '@/lib/utils';
import { appStore } from '@/store';

/**
 * ! You are likely looking to run emailLookup not iwcEmailLookup directly
 * Running this directly means handling of prev lookup and validate email
 * state must be implemented manually. e.g. see iwcAutofillEmailLookup
 */

// IWC returns null if there is an error
const validateLookup = (
  lookupResponse?:
    | never[]
    | { notified: boolean; context: string }
    | null
    | undefined,
): boolean => {
  const { setIdentityAuthProviderStatus, setIsAutoSmsNotified } =
    appStore.getActions().ui;
  if (Array.isArray(lookupResponse)) {
    logLookup(false, 'member');
    return true;
  } else if (lookupResponse) {
    const { context: updatedContext, notified } = lookupResponse;
    updateIwcContext(updatedContext);
    logLookup(true, 'member');
    // ! We do not currently catch race conditions on email change before res
    // Not going to add that in this PR and risk breaking OTP exp currently,
    // not sure if this has been an issue on prod but something to consider
    setIdentityAuthProviderStatus('eligible');
    setIsAutoSmsNotified(notified);
    return true;
  }

  logLookup(false, 'guest');
  return false;
};

/**
 * Looks up an email using IWC and sets app context if email is valid
 */
export const iwcEmailLookup = async (email: string): Promise<boolean> => {
  try {
    const {
      uri: { base },
      deferredQueryData: { otpLoginContext },
    } = getGlobals();

    const response = await lookup({
      context: otpLoginContext.context,
      options: {
        baseUri: isDev ? globalThis.location.origin : base,
      },
      publicCredential: email,
    });

    return validateLookup(response);
  } catch (err: any) {
    const { message, stack } = err || {};
    logger.warn('otp_lookup_error', { message, stack });
    return false;
  }
};
